/* Header behaviour: mobile drawer, search, menus.
   Was inlined into every page (about 15 KB, no Liquid in it). Loaded with
   defer, so the DOM is parsed before it runs. The inline version relied on
   the same thing by sitting after the markup. */
(function () {
  /* ── Mobile nav drawer ── */
  var hamburger = document.getElementById('smgHamburger');
  var nav       = document.getElementById('smgMobileNav');
  var overlay   = document.getElementById('smgNavOverlay');
  var closeBtn  = document.getElementById('smgNavClose');
  function openNav()  { nav.classList.add('is-open');    nav.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function closeNav() { nav.classList.remove('is-open'); nav.setAttribute('aria-hidden','true');  document.body.style.overflow=''; }
  if (hamburger) hamburger.addEventListener('click', openNav);
  if (overlay)   overlay.addEventListener('click', closeNav);
  if (closeBtn)  closeBtn.addEventListener('click', closeNav);

  /* ── Accordion ── moved to the early inline script in smg-header.liquid (5 Oct 2026)
     so the menu sections open before this deferred file has loaded. */

  /* ── Search modal ── */
  var searchOpenBtn  = document.getElementById('smgSearchOpen');
  var searchPanel    = document.getElementById('smgSearchPanel');
  var searchOverlay  = document.getElementById('smgSearchOverlay');
  var searchCloseBtn = document.getElementById('smgSearchClose');
  var searchInput    = document.getElementById('smgSearchPanelInput');
  var searchResults  = document.getElementById('smgSearchPanelResults');

  function openSearch() {
    searchPanel.classList.add('is-open');
    searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ searchInput && searchInput.focus(); }, 350);
  }
  function closeSearch() {
    searchPanel.classList.remove('is-open');
    searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (searchOpenBtn)  searchOpenBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  if (searchOverlay)  searchOverlay.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSearch(); });

  /* ── AJAX predictive search ── */
  var searchTimer;
  var currentQuery = '';

  /* /search/suggest.json returns price as a decimal string in store currency (NOT cents)
     e.g. "1500.0" for Rs. 1,500, so we just parse and format, no /100 needed */
  function formatMoney(price) {
    var n = Math.round(parseFloat(price));
    if (isNaN(n)) return '';
    return 'Rs. ' + n.toLocaleString('en-PK', { minimumFractionDigits: 0 });
  }

  /* ── Shared fetch function ── */
  function smgFetchSearch(query, onSuccess, onError) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        onSuccess(products, query);
      })
      .catch(onError || function(){});
  }

  /* ── Mobile panel render ── */
  function renderMobileResults(products, query) {
    if (!products || products.length === 0) {
      searchResults.innerHTML =
        '<div class="smg-search-panel__no-results"><span>😔</span>No gifts found for "<strong>' +
        query + '</strong>". Try a different search.</div>';
      return;
    }
    var cards = products.map(function(p) {
      var img = p.featured_image && p.featured_image.url
        ? p.featured_image.url.replace(/(\.[^.]+)$/, '_300x300$1')
        : '';
      var imgEl = img
        ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '<div style="width:100%;aspect-ratio:1;display:flex;align-items:center;justify-content:center;font-size:36px;background:var(--smg-cream,#FFF3F6);">🎁</div>';
      var price = p.price ? formatMoney(p.price) : '';
      return '<a href="' + p.url + '" class="smg-search-result-card">' +
        imgEl +
        '<div class="smg-search-result-card__info">' +
          '<div class="smg-search-result-card__title">' + p.title + '</div>' +
          '<div class="smg-search-result-card__price">' + price + '</div>' +
        '</div></a>';
    }).join('');
    searchResults.innerHTML =
      '<div class="smg-search-results-grid">' + cards + '</div>' +
      '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="smg-search-panel__view-all">' +
        'View all results for "' + query + '" →</a>';
  }

  function doMobileSearch(query) {
    currentQuery = query;
    if (query.length < 2) {
      searchResults.innerHTML =
        '<div class="smg-search-panel__hint"><span class="smg-search-panel__hint-ic"><svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg></span>Type to search gifts, bouquets, cake boxes and more...</div>';
      return;
    }
    searchResults.innerHTML = '<div class="smg-search-panel__loading">Searching...</div>';
    smgFetchSearch(query, function(products, q){
      if (q !== currentQuery) return;
      renderMobileResults(products, q);
    }, function(){
      searchResults.innerHTML = '<div class="smg-search-panel__no-results"><span>⚠️</span>Something went wrong. Please try again.</div>';
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function(){
      clearTimeout(searchTimer);
      var q = this.value.trim();
      searchTimer = setTimeout(function(){ doMobileSearch(q); }, 280);
    });
    searchInput.addEventListener('keydown', function(e){
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = this.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
    });
  }

  /* ── Desktop instant search dropdown ── */
  var desktopInput    = document.getElementById('smgDesktopSearchInput');
  var desktopDropdown = document.getElementById('smgNavSearchDropdown');
  var desktopTimer;
  var desktopQuery    = '';

  function renderDesktopResults(products, query) {
    if (!desktopDropdown) return;
    if (!products || products.length === 0) {
      desktopDropdown.innerHTML =
        '<div class="smg-nav__search-dnone">😔 No gifts found for "<strong>' + query + '</strong>"</div>';
      desktopDropdown.style.display = 'block';
      return;
    }
    var rows = products.map(function(p) {
      var img = p.featured_image && p.featured_image.url
        ? p.featured_image.url.replace(/(\.[^.]+)$/, '_80x80$1')
        : '';
      var imgEl = img
        ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '<div class="smg-nav__search-ditem__no-img">🎁</div>';
      var price = p.price ? formatMoney(p.price) : '';
      return '<a href="' + p.url + '" class="smg-nav__search-ditem">' +
        imgEl +
        '<div class="smg-nav__search-ditem__body">' +
          '<div class="smg-nav__search-ditem__name">' + p.title + '</div>' +
          (price ? '<div class="smg-nav__search-ditem__price">' + price + '</div>' : '') +
        '</div></a>';
    }).join('');
    desktopDropdown.innerHTML = rows +
      '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="smg-nav__search-dfoot">' +
        'See all results for "' + query + '" →</a>';
    desktopDropdown.style.display = 'block';
  }

  function doDesktopSearch(query) {
    desktopQuery = query;
    if (!desktopDropdown) return;
    if (query.length < 2) {
      desktopDropdown.style.display = 'none';
      desktopDropdown.innerHTML = '';
      return;
    }
    smgFetchSearch(query, function(products, q){
      if (q !== desktopQuery) return;
      renderDesktopResults(products, q);
    });
  }

  function closeDesktopDropdown() {
    if (desktopDropdown) { desktopDropdown.style.display = 'none'; desktopDropdown.innerHTML = ''; }
    desktopQuery = '';
  }

  if (desktopInput) {
    desktopInput.addEventListener('input', function(){
      clearTimeout(desktopTimer);
      var q = this.value.trim();
      desktopTimer = setTimeout(function(){ doDesktopSearch(q); }, 250);
    });
    desktopInput.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { closeDesktopDropdown(); desktopInput.blur(); }
    });
    /* Close dropdown when clicking outside */
    document.addEventListener('click', function(e){
      if (desktopInput && !desktopInput.closest('form').contains(e.target)) {
        closeDesktopDropdown();
      }
    });
    /* Re-show dropdown if input already has value and regains focus */
    desktopInput.addEventListener('focus', function(){
      var q = this.value.trim();
      if (q.length >= 2) doDesktopSearch(q);
    });
  }

  /* ── SMG Cart Drawer ── */
  var cartOverlay  = document.getElementById('smgCartOverlay');
  var cartPanel    = document.getElementById('smgCartPanel');
  var cartBody     = document.getElementById('smgCartPanelBody');
  var cartFoot     = document.getElementById('smgCartPanelFoot');
  var cartCount    = document.getElementById('smgCartPanelCount');
  var cartSubtotal = document.getElementById('smgCartSubtotal');
  var cartCloseBtn = document.getElementById('smgCartPanelClose');

  function smgFormatMoney(cents) {
    return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-PK');
  }

  /* SMG_MINQTY (20 Oct 2026): extras sold per item with a minimum, "handle:minimum".
     Keep this in step with the min_qty_handles setting of sections/smg-cake-addons.liquid.
     Balloons left this list for SMG_BALLOONPACK below. */
  var SMG_MIN_QTY_RULES = '';
  /* SMG_BALLOONPACK (20 Oct 2026): "handle:pack size". The product has a pack variant
     ("First 5 balloons") and a single extra (title with "Extra"). The pack line is always
     quantity 1: its minus removes the pack and the extras, its plus adds one extra.
     Keep in step with pack_handles in smg-cake-addons.liquid and smg-cart.liquid. */
  var SMG_PACK_RULES = 'balloons:5';
  window.smgPackSize = function (handle) {
    var n = 0;
    SMG_PACK_RULES.replace(/\s/g, '').split(',').forEach(function (r) {
      var p = r.split(':');
      if (p[0] && p[0] === handle) n = Math.max(2, parseInt(p[1], 10) || 5);
    });
    return n;
  };
  window.smgPackIsExtra = function (title) { return /extra/i.test(String(title || '')); };
  /* Pack and extra lines in a cart, by handle: { balloons: { pack: item, extras: [items] } } */
  window.smgPackLines = function (items) {
    var out = {};
    (items || []).forEach(function (it) {
      if (!window.smgPackSize(it.handle)) return;
      var g = out[it.handle] || (out[it.handle] = { pack: null, packs: [], extras: [] });
      if (window.smgPackIsExtra(it.variant_title)) g.extras.push(it);
      else { g.packs.push(it); if (!g.pack) g.pack = it; }
    });
    return out;
  };
  /* A pack line above 1 (the same balloons added with two gifts) becomes one pack plus
     extras, the price the owner set: 5 for Rs 1,499 and Rs 300 for each one after.
     Resolves true when the cart was changed. Tried once per cart state. */
  var smgPackNormTried = {};
  window.smgPackNormalise = function (cart) {
    var groups = window.smgPackLines((cart && cart.items) || []);
    var updates = null, sig = '';
    Object.keys(groups).forEach(function (h) {
      var g = groups[h];
      if (!g.pack || g.packs.length !== 1 || g.pack.quantity <= 1 || g.extras.length > 1) return;
      var size = window.smgPackSize(h);
      var x = g.extras[0];
      var xid = x ? x.variant_id : 0;
      if (!xid) {
        var d = upsellLoad()[h];
        (d && d.variants || []).forEach(function (v) { if (!xid && window.smgPackIsExtra(v.title)) xid = v.id; });
      }
      if (!xid) return;
      updates = updates || {};
      updates[g.pack.variant_id] = 1;
      updates[xid] = (x ? x.quantity : 0) + size * (g.pack.quantity - 1);
      sig += h + g.pack.quantity + ':' + (x ? x.quantity : 0) + ';';
    });
    if (!updates || smgPackNormTried[sig]) return Promise.resolve(false);
    smgPackNormTried[sig] = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  };
  /* SMG_MULTIPICK: extras where several types are picked at once, each in its own quantity. */
  var SMG_MULTI_HANDLES = ['chocolates-sweets'];
  window.smgMinQty = function (handle) {
    var n = 1;
    SMG_MIN_QTY_RULES.replace(/\s/g, '').split(',').forEach(function (r) {
      var p = r.split(':');
      if (p[0] && p[0] === handle) n = Math.max(1, parseInt(p[1], 10) || 1);
    });
    return n;
  };

  /* "Pink Wrap, Medium (up to 50 roses)" for two option products such as the roses add on (10 Oct 2026). */
  function smgVariantLabel(item) {
    var o = item.options_with_values;
    if (o && o.length > 1) {
      return o.map(function (x) {
        var v = String(x.value || '');
        return (/wrap/i.test(x.name || '') && !/wrap/i.test(v)) ? v + ' Wrap' : v;
      }).join(', ');
    }
    return item.variant_title;
  }

  function smgRenderCart(cart) {
    var items = cart.items || [];
    var count = cart.item_count || 0;

    /* Update badge in panel */
    if (cartCount) cartCount.textContent = count;

    /* Update nav badge everywhere */
    document.querySelectorAll('.smg-nav__badge').forEach(function(el) {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
    });

    if (!items.length) {
      /* SMG_UXCART: an empty cart starts the next order with a clean delivery form. */
      try { window.localStorage.removeItem('smgDdDraft'); } catch (e) {}
      cartBody.innerHTML =
        '<div class="smg-cart-panel__empty">' +
          '<div class="smg-cart-panel__empty-icon">🛒</div>' +
          '<div class="smg-cart-panel__empty-text">Your cart is empty</div>' +
          '<div class="smg-cart-panel__empty-sub">Add a gift to get started</div>' +
        '</div>';
      if (cartFoot) cartFoot.style.display = 'none';
      smgUpsellSafe(cart);
      return;
    }

    var packGroups = window.smgPackLines(items); /* SMG_BALLOONPACK */
    var html = items.map(function(item) {
      var imgEl = item.featured_image && item.featured_image.url
        ? '<img class="smg-cart-item__img" src="' + item.featured_image.url.replace(/(\.[^.]+)$/, '_120x120$1') + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
        : '<div class="smg-cart-item__img-placeholder">🎁</div>';

      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="smg-cart-item__variant">' + smgVariantLabel(item) + '</div>' : '';

      /* Line item properties (add-ons, delivery, gift message) */
      var isCard = item.handle === DRAWER_CARD_HANDLE;
      var propsHtml = '';
      if (item.properties) {
        var propLines = Object.keys(item.properties)
          .filter(function(k) {
            if (!(item.properties[k] && String(item.properties[k]).trim())) return false;
            /* SMG_UXCART: private keys stay hidden, "Card Theme: Birthday" repeats the variant,
               and the card's words get their own box below. */
            if (k.charAt(0) === '_') return false;
            if (k === 'Card Theme' && String(item.properties[k]) === String(item.variant_title)) return false;
            if (isCard && k === 'Card Message') return false;
            return true;
          })
          .map(function(k) { return drawerEsc(k) + ': ' + drawerEsc(item.properties[k]); });
        if (propLines.length) {
          propsHtml = '<div class="smg-cart-item__props">' + propLines.join('<br>') + '</div>';
        }
      }
      if (isCard) {
        var cardText = Object.prototype.hasOwnProperty.call(drawerCardTyped, item.key)
          ? drawerCardTyped[item.key] : String((item.properties || {})['Card Message'] || '');
        var cid = 'smgDrawerCard' + (++drawerCardSeq);
        propsHtml += '<div class="smg-cart-item__cardmsg' + (cardText.trim().length < 2 ? ' is-empty' : '') + '">' +
          '<label for="' + cid + '">Card Message</label>' +
          '<textarea id="' + cid + '" class="smg-cart-item__cardmsg-input" maxlength="300" rows="3" data-key="' + drawerEsc(item.key) + '" data-qty="' + item.quantity + '" data-props="' + drawerEsc(JSON.stringify(item.properties || {})) + '" placeholder="Their name, your message and your name">' + drawerEsc(cardText) + '</textarea>' +
          '<div class="smg-cart-item__cardmsg-note" aria-live="polite">Needed before you order. We print it exactly as you type it.</div>' +
        '</div>';
      }

      var linePrice = item.line_price || (item.price * item.quantity);
      /* SMG_MINQTY */
      var lineMin = window.smgMinQty(item.handle);
      var lessQty = (item.quantity - 1 < lineMin) ? 0 : item.quantity - 1;
      var moreQty = Math.max(item.quantity + 1, lineMin);
      /* SMG_BALLOONPACK: the pack line steps as a whole; an extra with no pack asks for it. */
      var pk = packInfo(item, packGroups);
      var minusCls = 'smg-cart-qty-minus', plusCls = 'smg-cart-qty-plus', removeCls = 'smg-cart-remove';
      var minusAttr = '', plusAttr = '', minusLabel = (lessQty === 0 && lineMin > 1 ? 'Remove, minimum ' + lineMin : 'Decrease'), plusLabel = 'Increase';
      if (pk && pk.isPack) {
        minusCls = 'smg-cart-pack-minus'; removeCls = 'smg-cart-pack-minus';
        minusAttr = ' data-keys="' + drawerEsc(pk.keys.join(',')) + '"';
        minusLabel = 'Remove ' + item.product_title;
        if (pk.extraKey) { plusAttr = ' data-xkey="' + drawerEsc(pk.extraKey) + '" data-xqty="' + pk.extraQty + '"'; }
        else if (pk.extraId) { plusAttr = ' data-xid="' + pk.extraId + '"'; }
        plusCls = (pk.extraKey || pk.extraId) ? 'smg-cart-pack-plus' : 'smg-cart-pack-none';
        plusLabel = 'Add one extra balloon';
        if (pk.extraPrice) propsHtml += '<div class="smg-cart-item__props">Extra balloons ' + smgFormatMoney(pk.extraPrice) + ' each, tap + to add one.</div>';
      } else if (pk && pk.orphan) {
        propsHtml += '<div class="smg-cart-item__props" style="color:#C0392B">Extra balloons go with the first ' + pk.size + ' balloons.' +
          (pk.packId ? ' <button type="button" class="smg-cart-pack-add" data-id="' + pk.packId + '" style="margin-top:6px;display:inline-block;padding:6px 12px;border-radius:999px;border:1.5px solid var(--smg-primary,#E8365D);background:#fff;color:var(--smg-primary,#E8365D);font:inherit;font-size:12.5px;font-weight:700;cursor:pointer">Add the first ' + pk.size + (pk.packPrice ? ', ' + smgFormatMoney(pk.packPrice) : '') + '</button>' : '') +
          '</div>';
      }

      return '<div class="smg-cart-item" data-key="' + item.key + '" data-variant="' + item.variant_id + '">' +
        imgEl +
        '<div class="smg-cart-item__info">' +
          '<div class="smg-cart-item__name">' + item.product_title + '</div>' +
          variantLine +
          propsHtml +
          '<div class="smg-cart-item__row">' +
            '<span class="smg-cart-item__price">' + smgFormatMoney(linePrice) + '</span>' +
            '<div class="smg-cart-item__actions">' +
              '<div class="smg-cart-item__qty">' +
                '<button class="smg-cart-item__qty-btn ' + minusCls + '" data-key="' + item.key + '" data-qty="' + lessQty + '"' + minusAttr + ' aria-label="' + drawerEsc(minusLabel) + '">&#8722;</button>' +
                '<span class="smg-cart-item__qty-num">' + item.quantity + '</span>' +
                '<button class="smg-cart-item__qty-btn ' + plusCls + '" data-key="' + item.key + '" data-qty="' + moreQty + '"' + plusAttr + ' aria-label="' + plusLabel + '"' + (plusCls === 'smg-cart-pack-none' ? ' disabled' : '') + '>+</button>' +
              '</div>' +
              '<button class="smg-cart-item__remove ' + removeCls + '" data-key="' + item.key + '"' + minusAttr + ' aria-label="Remove">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    cartBody.innerHTML = html;
    drawerCardTyped = {};

    if (cartSubtotal) cartSubtotal.textContent = smgFormatMoney(cart.total_price || 0);
    /* Minimum order Rs 4,999 (10 Oct 2026), same rule as the cart page. */
    var minEl = document.getElementById('smgCartMin');
    if (minEl) {
      var left = 499900 - (cart.total_price || 0);
      if (left > 0) {
        minEl.innerHTML = '<strong>Minimum order is Rs 4,999.</strong> Add ' + smgFormatMoney(left) + ' more to place your order.';
        minEl.hidden = false;
      } else {
        minEl.hidden = true;
      }
    }
    if (cartFoot) cartFoot.style.display = '';

    /* Qty + remove handlers */
    cartBody.querySelectorAll('.smg-cart-qty-minus, .smg-cart-qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.key;
        var qty = parseInt(this.dataset.qty, 10);
        smgUpdateCartItem(key, qty < 0 ? 0 : qty);
      });
    });
    cartBody.querySelectorAll('.smg-cart-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        smgUpdateCartItem(this.dataset.key, 0);
      });
    });
    /* SMG_BALLOONPACK: minus or Remove on the pack clears the pack and its extras together. */
    cartBody.querySelectorAll('.smg-cart-pack-minus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var u = {};
        String(this.dataset.keys || this.dataset.key).split(',').forEach(function (k) { if (k) u[k] = 0; });
        smgPackPost('/cart/update.js', { updates: u });
      });
    });
    cartBody.querySelectorAll('.smg-cart-pack-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (this.dataset.xkey) smgUpdateCartItem(this.dataset.xkey, (parseInt(this.dataset.xqty, 10) || 0) + 1);
        else smgPackPost('/cart/add.js', { items: [{ id: parseInt(this.dataset.xid, 10), quantity: 1 }] });
      });
    });
    cartBody.querySelectorAll('.smg-cart-pack-add').forEach(function(btn) {
      btn.addEventListener('click', function() {
        smgPackPost('/cart/add.js', { items: [{ id: parseInt(this.dataset.id, 10), quantity: 1 }] });
      });
    });

    smgUpsellSafe(cart);
    /* SMG_BALLOONPACK: a pack line above 1 is folded into one pack plus extras. */
    window.smgPackNormalise(cart).then(function (changed) {
      if (changed) { smgRefreshCartPanel(); drawerTellCartPage(); }
    });
  }

  /* SMG_BALLOONPACK helpers for the drawer lines. */
  function packInfo(item, groups) {
    var size = window.smgPackSize(item.handle);
    if (!size) return null;
    var g = groups[item.handle] || { pack: null, extras: [] };
    var d = upsellLoad()[item.handle];
    var dv = (d && d.variants) || [];
    var findV = function (wantExtra) { for (var i = 0; i < dv.length; i++) { if (window.smgPackIsExtra(dv[i].title) === wantExtra) return dv[i]; } return null; };
    if (!window.smgPackIsExtra(item.variant_title)) {
      var x = g.extras[0] || null, xv = findV(true);
      var keys = [item.key].concat(g.extras.map(function (e) { return e.key; }));
      return { isPack: true, size: size, keys: keys, extraKey: x ? x.key : '', extraQty: x ? x.quantity : 0,
        extraId: x ? x.variant_id : (xv ? xv.id : 0), extraPrice: x ? x.price : (xv ? xv.price : 0) };
    }
    if (!g.pack) {
      var pv = findV(false);
      return { orphan: true, size: size, packId: pv ? pv.id : 0, packPrice: pv ? pv.price : 0 };
    }
    return null;
  }
  function smgPackPost(url, body) {
    cartBody.style.opacity = '0.5';
    drawerKeepTyped();
    drawerEnqueue(function () {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    })
    .then(function () { cartBody.style.opacity = ''; return smgRefreshCartPanel(); })
    .then(function () { drawerTellCartPage(); })
    .catch(function () { cartBody.style.opacity = ''; smgRefreshCartPanel(); });
  }

  function smgUpdateCartItem(key, qty) {
    cartBody.style.opacity = '0.5';
    drawerKeepTyped();
    drawerEnqueue(function () {
      return fetch('/cart/change.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      cartBody.style.opacity = '';
      smgRenderCart(cart);
      drawerTellCartPage();
    })
    .catch(function() { cartBody.style.opacity = ''; });
  }

  /* ── SMG_UXCART (20 Oct 2026): printed card message in the cart panel ──
     Same property as the product page and the extras rail ('Card Message'), saved with
     /cart/change.js as it is typed. Changes go one at a time so a quantity tap and a
     message save never overwrite each other. Text being typed survives a re-render. */
  var DRAWER_CARD_HANDLE = 'custom-printed-greeting-card';
  var drawerQueue = Promise.resolve(), drawerCardTyped = {}, drawerCardSeq = 0, drawerTimers = {};
  function drawerEnqueue(fn) {
    var p = drawerQueue.then(fn, fn);
    drawerQueue = p.catch(function () {});
    return p;
  }
  function drawerEsc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function drawerClean(v) { return String(v || '').replace(/[\uD800-\uDFFF]/g, '').replace(/[ \t]+\n/g, '\n').trim(); }
  function drawerKeepTyped() {
    if (!cartBody) return;
    cartBody.querySelectorAll('.smg-cart-item__cardmsg-input[data-dirty="1"]').forEach(function (ta) {
      drawerCardTyped[ta.getAttribute('data-key')] = ta.value;
    });
  }
  /* The cart page lists the same lines; let it catch up after a change made here. */
  function drawerTellCartPage() {
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      try { document.dispatchEvent(new CustomEvent('smg:cart-changed')); } catch (e) {}
    }
  }
  function drawerCardSave(ta) {
    var text = drawerClean(ta.value);
    var props = {};
    try { props = JSON.parse(ta.getAttribute('data-props') || '{}') || {}; } catch (e) { props = {}; }
    if ((props['Card Message'] || '') === text) { ta.removeAttribute('data-dirty'); return Promise.resolve(); }
    /* Shopify merges properties on a change, so a cleared message is sent as an empty value. */
    props['Card Message'] = text;
    var note = ta.parentNode && ta.parentNode.querySelector('.smg-cart-item__cardmsg-note');
    if (note) note.textContent = 'Saving...';
    return drawerEnqueue(function () {
      var oldKey = ta.getAttribute('data-key');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: oldKey, quantity: parseInt(ta.getAttribute('data-qty'), 10) || 1, properties: props })
      }).then(function (r) { if (!r.ok) throw new Error('save'); return r.json(); }).then(function (cart) {
        /* The line's key changes with its properties: point every control in this line at the new one. */
        var vid = String(oldKey).split(':')[0], it = null;
        (cart.items || []).forEach(function (x) {
          if (!it && String(x.variant_id) === vid && ((x.properties || {})['Card Message'] || '') === (props['Card Message'] || '')) it = x;
        });
        if (it) {
          var row = ta.closest('.smg-cart-item');
          if (row) {
            row.setAttribute('data-key', it.key);
            row.querySelectorAll('[data-key]').forEach(function (el) { el.setAttribute('data-key', it.key); });
          }
          ta.setAttribute('data-props', JSON.stringify(it.properties || {}));
        }
        if (drawerClean(ta.value) === text) ta.removeAttribute('data-dirty');
        if (note) note.textContent = text ? 'Saved' : 'Needed before you order. We print it exactly as you type it.';
        drawerTellCartPage();
      });
    }).catch(function () {
      if (note) note.textContent = 'Not saved yet. Open the cart page to check it before you order.';
    });
  }
  if (cartBody) {
    cartBody.addEventListener('input', function (e) {
      var ta = e.target;
      if (!ta.classList || !ta.classList.contains('smg-cart-item__cardmsg-input')) return;
      ta.setAttribute('data-dirty', '1');
      var box = ta.parentNode;
      if (box) box.classList.toggle('is-empty', drawerClean(ta.value).length < 2);
      clearTimeout(drawerTimers[ta.id]);
      drawerTimers[ta.id] = setTimeout(function () { drawerCardSave(ta); }, 900);
    });
    cartBody.addEventListener('focusout', function (e) {
      var ta = e.target;
      if (ta.classList && ta.classList.contains('smg-cart-item__cardmsg-input') && ta.getAttribute('data-dirty') === '1') {
        clearTimeout(drawerTimers[ta.id]);
        drawerCardSave(ta);
      }
    });
    /* CSS lives here, with the markup it styles, not in the shared stylesheet. */
    if (!document.getElementById('smgDrawerCardCss')) {
      var st = document.createElement('style');
      st.id = 'smgDrawerCardCss';
      st.textContent =
        '.smg-cart-item__cardmsg{margin:6px 0 8px}' +
        '.smg-cart-item__cardmsg label{display:block;font-size:12px;font-weight:700;color:var(--smg-deep,#4A1228);margin-bottom:4px}' +
        '.smg-cart-item__cardmsg-input{width:100%;box-sizing:border-box;min-height:72px;resize:vertical;border:1.5px solid var(--smg-border,#F0E0E6);border-radius:10px;padding:8px 10px;font-family:inherit;font-size:16px;line-height:1.35;color:var(--smg-text,#2D2024);background:#fff}' +
        '.smg-cart-item__cardmsg-input:focus{outline:none;border-color:var(--smg-primary,#E8365D)}' +
        '.smg-cart-item__cardmsg-note{font-size:11.5px;line-height:1.4;color:var(--smg-text-muted,#7A5A65);margin-top:3px}' +
        '.smg-cart-item__cardmsg.is-empty .smg-cart-item__cardmsg-input{border-color:#E0A3A3}' +
        '.smg-cart-item__cardmsg.is-empty .smg-cart-item__cardmsg-note{color:#C0392B}';
      document.head.appendChild(st);
    }
  }

  function smgRefreshCartPanel() {
    drawerKeepTyped();
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { smgRenderCart(cart); return cart; })
      .catch(function() {
        if (cartBody) cartBody.innerHTML = '<div class="smg-cart-panel__empty"><div class="smg-cart-panel__empty-icon">⚠️</div><div class="smg-cart-panel__empty-text">Could not load cart</div></div>';
      });
  }

  function smgOpenCart() {
    cartPanel.classList.add('is-open');
    cartPanel.setAttribute('aria-hidden', 'false');
    cartOverlay.classList.add('is-open');
    cartOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    smgRefreshCartPanel();
  }

  function smgCloseCart() {
    cartPanel.classList.remove('is-open');
    cartPanel.setAttribute('aria-hidden', 'true');
    cartOverlay.classList.remove('is-open');
    cartOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartCloseBtn) cartCloseBtn.addEventListener('click', smgCloseCart);
  if (cartOverlay) cartOverlay.addEventListener('click', smgCloseCart);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartPanel && cartPanel.classList.contains('is-open')) smgCloseCart();
  });

  /* Make cart icon open drawer instead of navigating */
  document.querySelectorAll('.smg-nav__icon-btn[aria-label="Cart"]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      smgOpenCart();
    });
  });

  /* ── Cart panel: "Make it extra special" rail (4 Oct 2026) ──
     The product data is printed by smg-header.liquid into #smgUpsellData, in
     stock variants only. Each card is built once and kept, so a picked variant
     or a half written card message survives the panel re-rendering after every
     quantity change. Which cards show is worked out from the cart each time:
     an add on already in the cart is hidden (unless it was just added here,
     then it stays as "Added"), red roses hide when the cart already has
     flowers, the Layers cake hides when there is a cake, the cake tag only
     shows with a cake. Line item properties for the greeting card use the
     same names as smg-cake-addons.liquid ('Card Theme', 'Card Message'), so
     the cart page and the WhatsApp order message print them unchanged. */
  var UPSELL_ORDER = ['custom-printed-greeting-card', 'chocolates-sweets', 'balloons', 'red-roses-bouquet-addon', 'layers-cakes', 'teddy-bear'];
  var UPSELL_ROSES = 'red-roses-bouquet-addon';
  var UPSELL_MAX = 6;
  var UPSELL_CARD_HANDLE = 'custom-printed-greeting-card';
  var UPSELL_SKIP_KEY = 'smgUpsellSkipped';
  /* Roses card since 10 Oct 2026: the red-roses-bouquet-addon product (Wrap Colour and Size).
     The colour bouquets (red-roses-bouquet-red-wrap and the others) are not listed here, so
     bought on their own they are main gifts and still get the rail. */
  var UPSELL_ADDON_HANDLES = UPSELL_ORDER.concat(['pvc-gift-box', 'decorated-acrylic-box', 'flowers-bouquet', 'chocolates-box']);
  /* SMG_RAILBOX (11 Oct 2026): every cake goes in a gift box, so it looks beautiful with the
     gift. Same rule as the WhatsApp order check in sections/smg-cart.liquid: cakes are Custom
     Theme Cake and Signature Cake products, the Layers cake extra, and (SMG_CAKEBOX_TAG,
     28 Oct 2026) any product tagged needs-cake-box, the combos and trays with a cake in them.
     cart.js has no tags, so smg-header.liquid prints the tagged handles in the cart (and the
     product on its own page) into #smgCakeBoxHandles. Boxes are the PVC and acrylic box. */
  var UPSELL_BOXES = ['pvc-gift-box', 'decorated-acrylic-box'];
  window.smgCakeBoxTagged = function (it) {
    if (!it || !it.handle) return false;
    var list = [];
    try { list = JSON.parse((document.getElementById('smgCakeBoxHandles') || {}).textContent || '[]') || []; } catch (e) { list = []; }
    return list.indexOf(it.handle) !== -1;
  };
  window.smgCakeBoxCount = function (items) {
    var cake = 0, box = 0;
    (items || []).forEach(function (it) {
      var t = it.product_type || '';
      if (t === 'Custom Theme Cake' || t === 'Signature Cake' || it.handle === 'layers-cakes' || window.smgCakeBoxTagged(it)) cake += it.quantity || 0;
      if (UPSELL_BOXES.indexOf(it.handle) !== -1) box += it.quantity || 0;
    });
    return { cake: cake, box: box };
  };
  var upsellBoxNeed = false;
  var UPSELL_NAMES = {
    'pvc-gift-box': 'Decorated Clear PVC Gift Box',
    'decorated-acrylic-box': 'Decorated Acrylic Box',
    'custom-printed-greeting-card': 'Printed Greeting Card',
    'custom-gift-tag': 'Custom Cake Tag',
    'chocolates-sweets': 'Chocolates',
    'balloons': 'Heart Helium Balloons',
    'red-roses-bouquet-addon': 'Red Roses Bouquet',
    'layers-cakes': 'Layers Bakery Cake',
    'teddy-bear': 'Teddy Bear'
  };
  var UPSELL_NOTES = {
    'pvc-gift-box': 'Makes the cake look beautiful with your gift',
    'decorated-acrylic-box': 'Makes the cake look beautiful with your gift',
    'custom-printed-greeting-card': '5 x 7 inch, your words printed',
    'custom-gift-tag': 'To go on the cake'
  };
  var upsellProducts = null, upsellEl = null, upsellTrack = null, upsellForm = null;
  var upsellCards = {}, upsellAdded = {}, upsellScroll = 0, upsellSkipMem = false;

  function upsellLoad() {
    if (upsellProducts) return upsellProducts;
    upsellProducts = {};
    var el = document.getElementById('smgUpsellData');
    var list = [];
    try { list = el ? JSON.parse(el.textContent) : []; } catch (e) { list = []; }
    list.forEach(function (p) {
      if (p && p.handle && p.variants && p.variants.length) upsellProducts[p.handle] = p;
    });
    return upsellProducts;
  }

  function upsellIsSkipped() {
    try { return window.sessionStorage.getItem(UPSELL_SKIP_KEY) === '1'; } catch (e) { return upsellSkipMem; }
  }
  function upsellSetSkipped(on) {
    upsellSkipMem = on;
    try {
      if (on) window.sessionStorage.setItem(UPSELL_SKIP_KEY, '1');
      else window.sessionStorage.removeItem(UPSELL_SKIP_KEY);
    } catch (e) {}
  }

  function upsellIsAddon(item) {
    var t = (item.product_type || '').toLowerCase();
    return t === 'addon' || t === 'add-on' || UPSELL_ADDON_HANDLES.indexOf(item.handle) !== -1;
  }

  function upsellEl_(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function upsellVariant(p, id) {
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(id)) return p.variants[i];
    }
    return p.variants[0];
  }

  /* Customer text goes into the WhatsApp order message, where 4 byte emoji
     arrive as "?" on some phones, and a printed card cannot carry them anyway. */
  function upsellCleanText(s) {
    return String(s || '').replace(/[\uD800-\uDFFF]/g, '').replace(/[ \t]+\n/g, '\n').trim();
  }

  function upsellBuildShell() {
    upsellEl = upsellEl_('section', 'smg-upsell');
    upsellEl.id = 'smgUpsell';
    upsellEl.setAttribute('aria-label', 'Make it extra special');

    var head = upsellEl_('div', 'smg-upsell__head');
    head.appendChild(upsellEl_('h3', 'smg-upsell__title', 'Make it extra special'));
    var skip = upsellEl_('button', 'smg-upsell__skip', 'No thanks');
    skip.type = 'button';
    skip.addEventListener('click', function () {
      var collapse = !upsellEl.classList.contains('is-collapsed');
      upsellSetSkipped(collapse);
      upsellApplyCollapsed();
    });
    head.appendChild(skip);
    upsellEl.appendChild(head);

    upsellEl.appendChild(upsellEl_('p', 'smg-upsell__sub', 'Little extras delivered with your gift, tap to add.'));

    upsellTrack = upsellEl_('div', 'smg-upsell__track');
    upsellTrack.setAttribute('role', 'list');
    upsellTrack.addEventListener('scroll', function () { upsellScroll = upsellTrack.scrollLeft; }, { passive: true });
    upsellEl.appendChild(upsellTrack);
  }

  function upsellApplyCollapsed() {
    if (!upsellEl) return;
    /* SMG_RAILBOX: never fold the rail away while a cake still needs its box. */
    var on = upsellIsSkipped() && !upsellBoxNeed;
    upsellEl.classList.toggle('is-collapsed', on);
    var skip = upsellEl.querySelector('.smg-upsell__skip');
    if (skip) {
      skip.textContent = on ? 'Show extras' : 'No thanks';
      skip.setAttribute('aria-expanded', on ? 'false' : 'true');
    }
    if (on) upsellCloseForm();
  }

  function upsellBuildCard(p) {
    var card = upsellEl_('div', 'smg-upsell__card');
    card.setAttribute('role', 'listitem');
    card.dataset.handle = p.handle;
    var name = UPSELL_NAMES[p.handle] || p.title;
    var isGreeting = p.handle === UPSELL_CARD_HANDLE;

    var img;
    if (p.image) {
      img = upsellEl_('img', 'smg-upsell__img');
      img.src = p.image; img.alt = name; img.loading = 'lazy';
      img.width = 300; img.height = 300;
    } else {
      img = upsellEl_('div', 'smg-upsell__img smg-upsell__img--empty', '🎁');
    }
    card.appendChild(img);
    card.appendChild(upsellEl_('div', 'smg-upsell__name', name));
    if (UPSELL_NOTES[p.handle]) card.appendChild(upsellEl_('div', 'smg-upsell__note', UPSELL_NOTES[p.handle]));
    var price = upsellEl_('div', 'smg-upsell__price', smgFormatMoney(p.variants[0].price));
    card.appendChild(price);
    /* SMG_BALLOONPACK: "5 for Rs. 1,499", the extra price under it, and the pack goes in once. */
    var packSize = window.smgPackSize(p.handle), packV = null, packX = null;
    if (packSize) {
      p.variants.forEach(function (v) {
        if (window.smgPackIsExtra(v.title)) { if (!packX) packX = v; }
        else if (!packV) packV = v;
      });
      if (packV && packX) {
        price.textContent = packSize + ' for ' + smgFormatMoney(packV.price);
        card.appendChild(upsellEl_('div', 'smg-upsell__note', 'Extra balloons ' + smgFormatMoney(packX.price) + ' each'));
        card._smgAddLabel = 'Add ' + packSize;
        card._smgCurrent = function () { return packV; };
      } else { packSize = 0; }
    }
    /* SMG_MINQTY: "Rs. 399 each" and the minimum, worked out from the real price. */
    var minQ = window.smgMinQty(p.handle);
    if (minQ > 1 && p.variants.length === 1) {
      price.textContent = smgFormatMoney(p.variants[0].price) + ' each';
      card.appendChild(upsellEl_('div', 'smg-upsell__note', 'Minimum ' + minQ + ', ' + smgFormatMoney(p.variants[0].price * minQ)));
      card._smgAddLabel = 'Add ' + minQ;
    }
    /* SMG_MULTIPICK: a list of types, each with its own quantity, added together. */
    var isMultiPick = !packSize && !isGreeting && p.variants.length > 1 && SMG_MULTI_HANDLES.indexOf(p.handle) !== -1;
    if (isMultiPick) {
      price.textContent = 'From ' + smgFormatMoney(Math.min.apply(null, p.variants.map(function (v) { return v.price; })));
      var mpick = upsellEl_('div', 'smg-upsell__pick smg-upsell__pick--multi');
      mpick.setAttribute('role', 'button');
      mpick.setAttribute('tabindex', '0');
      mpick.setAttribute('aria-haspopup', 'dialog');
      mpick.appendChild(upsellEl_('span', 'smg-upsell__pick-text', /^(choose|select)/i.test(p.option || '') ? p.option : 'Choose types'));
      mpick.appendChild(upsellEl_('span', 'smg-upsell__pick-caret'));
      var openMulti = function () { if (!card.classList.contains('is-added')) upsellOpenMulti(p, name, card); };
      mpick.addEventListener('click', openMulti);
      mpick.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openMulti(); } });
      card.appendChild(mpick);
      card._smgMultiOpen = openMulti;
    }

    var sel = null;
    var multi = !packSize && !isGreeting && p.variants.length > 1 && p.options && p.options.length === 2 && p.variants.every(function (v) { return v.o && v.o.length === 2; });
    var picks = [];
    if (multi) {
      /* Two options (roses: Wrap Colour then Size): one picker each, starting on the first
         variant (Red, Mini). A pair that is not on sale moves the other picker to one that is. */
      var cur = p.variants[0];
      var optText = function (i, val) {
        return (i === 0 && /wrap/i.test(p.options[0]) && !/wrap/i.test(val)) ? val + ' Wrap' : val;
      };
      var findV = function (vals) {
        for (var k = 0; k < p.variants.length; k++) {
          if (p.variants[k].o[0] === vals[0] && p.variants[k].o[1] === vals[1]) return p.variants[k];
        }
        return null;
      };
      var paint = function () {
        price.textContent = smgFormatMoney(cur.price);
        if (cur.image && img.tagName === 'IMG') img.src = cur.image;
        picks.forEach(function (pk, i) { pk.sel.value = cur.o[i]; pk.text.textContent = optText(i, cur.o[i]); });
        card.dataset.variant = cur.id;
      };
      [0, 1].forEach(function (i) {
        var seen = {};
        var pk = upsellEl_('div', 'smg-upsell__pick');
        var pt = upsellEl_('span', 'smg-upsell__pick-text', '');
        pk.appendChild(pt);
        pk.appendChild(upsellEl_('span', 'smg-upsell__pick-caret'));
        var s = upsellEl_('select', 'smg-upsell__select');
        s.setAttribute('aria-label', p.options[i] + ' for ' + name);
        p.variants.forEach(function (v) {
          if (seen[v.o[i]]) return;
          seen[v.o[i]] = true;
          var o = upsellEl_('option', null, optText(i, v.o[i]));
          o.value = v.o[i];
          o.setAttribute('data-name', optText(i, v.o[i]));
          if (v.image) o.setAttribute('data-image', v.image);
          if (i === 1) o.setAttribute('data-price', v.price);
          s.appendChild(o);
        });
        s.addEventListener('change', function () {
          var vals = [cur.o[0], cur.o[1]];
          vals[i] = s.value;
          var v = findV(vals);
          if (!v) { for (var k = 0; k < p.variants.length; k++) { if (p.variants[k].o[i] === s.value) { v = p.variants[k]; break; } } }
          if (v) cur = v;
          paint();
        });
        pk.appendChild(s);
        card.appendChild(pk);
        if (window.smgEnhanceSelect) window.smgEnhanceSelect(s, { trigger: pk, title: name + ', ' + p.options[i], image: p.image });
        picks.push({ sel: s, text: pt });
      });
      paint();
      card._smgCurrent = function () { return cur; };
    }
    if (!packSize && !multi && !isMultiPick && !isGreeting && p.variants.length > 1) {
      /* The native select sits invisibly over a small label, so the chosen
         option reads in full at card size while the select keeps 16px text
         (anything smaller makes iPhones zoom the page on tap). */
      var pick = upsellEl_('div', 'smg-upsell__pick');
      var pickText = upsellEl_('span', 'smg-upsell__pick-text', p.variants[0].title);
      pick.appendChild(pickText);
      pick.appendChild(upsellEl_('span', 'smg-upsell__pick-caret'));
      sel = upsellEl_('select', 'smg-upsell__select');
      sel.setAttribute('aria-label', (p.option || 'Option') + ' for ' + name);
      p.variants.forEach(function (v) {
        var o = upsellEl_('option', null, v.title);
        o.value = v.id;
        o.setAttribute('data-name', v.title);
        o.setAttribute('data-price', v.price);
        if (v.image) o.setAttribute('data-image', v.image);
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        var v = upsellVariant(p, sel.value);
        price.textContent = smgFormatMoney(v.price);
        pickText.textContent = v.title;
        if (v.image && img.tagName === 'IMG') img.src = v.image;
      });
      pick.appendChild(sel);
      card.appendChild(pick);
      if (window.smgEnhanceSelect) window.smgEnhanceSelect(sel, { trigger: pick, title: name, image: p.image });
    }

    var btn = upsellEl_('button', 'smg-upsell__add', card._smgAddLabel || 'Add');
    btn.type = 'button';
    btn.setAttribute('aria-label', (card._smgAddLabel || 'Add') + ' ' + name);
    btn.addEventListener('click', function () {
      if (card.classList.contains('is-added') || btn.disabled) return;
      if (isGreeting) { upsellOpenForm(p, btn); return; }
      if (card._smgMultiOpen) { card._smgMultiOpen(); return; }
      var v = card._smgCurrent ? card._smgCurrent() : sel ? upsellVariant(p, sel.value) : p.variants[0];
      upsellAdd(p, v, null, btn);
    });
    card.appendChild(btn);
    return card;
  }

  /* The greeting card is printed, so the words are taken before it is added. */
  function upsellOpenForm(p, cardBtn) {
    if (!upsellForm) {
      upsellForm = upsellEl_('div', 'smg-upsell__form');
      upsellForm.innerHTML =
        '<div class="smg-upsell__form-title">Your printed greeting card</div>' +
        '<p class="smg-upsell__form-note">Rs. 199. A 5 x 7 inch card printed in English or Urdu with their name, your message and your name.</p>' +
        '<label class="smg-upsell__label" for="smgUpsellOcc">Occasion</label>' +
        '<select class="smg-upsell__input" id="smgUpsellOcc"><option value="">Choose the occasion</option></select>' +
        '<label class="smg-upsell__label" for="smgUpsellMsg">What should the card say?</label>' +
        '<textarea class="smg-upsell__input smg-upsell__textarea" id="smgUpsellMsg" maxlength="300" rows="4" placeholder="Write their name, your message and your name, we print it exactly as you type it"></textarea>' +
        '<div class="smg-upsell__count" id="smgUpsellCount">0 / 300</div>' +
        '<div class="smg-upsell__err" id="smgUpsellErr" role="alert"></div>' +
        '<div class="smg-upsell__form-btns">' +
          '<button type="button" class="smg-upsell__form-add" id="smgUpsellCardAdd"></button>' +
          '<button type="button" class="smg-upsell__form-cancel" id="smgUpsellCardCancel">Cancel</button>' +
        '</div>';
      var occ = upsellForm.querySelector('#smgUpsellOcc');
      p.variants.forEach(function (v) {
        var o = upsellEl_('option', null, v.title);
        o.value = v.id;
        occ.appendChild(o);
      });
      if (window.smgEnhanceSelect) window.smgEnhanceSelect(occ, { title: 'Choose the occasion', size: 'full' });
      var msg = upsellForm.querySelector('#smgUpsellMsg');
      var count = upsellForm.querySelector('#smgUpsellCount');
      var err = upsellForm.querySelector('#smgUpsellErr');
      var addBtn = upsellForm.querySelector('#smgUpsellCardAdd');
      addBtn.textContent = 'Add card, ' + smgFormatMoney(p.variants[0].price);
      msg.addEventListener('input', function () { count.textContent = msg.value.length + ' / 300'; err.textContent = ''; });
      occ.addEventListener('change', function () { err.textContent = ''; });
      upsellForm.querySelector('#smgUpsellCardCancel').addEventListener('click', upsellCloseForm);
      addBtn.addEventListener('click', function () {
        var text = upsellCleanText(msg.value);
        if (!occ.value) { err.textContent = 'Please choose the occasion.'; if (occ._smgPick) occ._smgPick.open(); else occ.focus(); return; }
        if (text.length < 2) { err.textContent = 'Please write what the card should say.'; msg.focus(); return; }
        var v = upsellVariant(p, occ.value);
        upsellAdd(p, v, { 'Card Theme': v.title, 'Card Message': text }, addBtn, function () {
          msg.value = ''; occ.value = ''; if (occ._smgPick) occ._smgPick.sync(); count.textContent = '0 / 300';
          upsellCloseForm();
        });
      });
    }
    upsellEl.appendChild(upsellForm);
    upsellForm.hidden = false;
    if (cardBtn) cardBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () {
      try { upsellForm.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }, 30);
  }

  function upsellCloseForm() {
    if (upsellForm) upsellForm.hidden = true;
    var c = upsellCards[UPSELL_CARD_HANDLE];
    if (c) { var b = c.querySelector('.smg-upsell__add'); if (b) b.setAttribute('aria-expanded', 'false'); }
  }

  function upsellAdd(p, v, props, btn, onDone) {
    var label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';
    var item = { id: v.id, quantity: window.smgPackSize(p.handle) ? 1 : window.smgMinQty(p.handle) }; /* SMG_BALLOONPACK: the pack goes in once */
    if (props) item.properties = props;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
    .then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) throw new Error(r.status === 429 ? 'Busy, tap again' : (d.description || d.message || 'Try again'));
        return d;
      });
    })
    .then(function () {
      upsellAdded[p.handle] = true;
      /* SMG_TRACK1013 */
      try { if (window.smgTrack) window.smgTrack('add_extra', { extra_name: p.title || p.handle, extra_variant: v.title || '', value: (v.price || 0) * item.quantity / 100, currency: 'PKR', source: 'cart_rail' }); } catch (e) {}
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.textContent = label;
      if (onDone) onDone();
      /* add_to_cart for GA4 is sent by the Google and YouTube app pixel */
      return smgRefreshCartPanel();
    })
    .catch(function (e) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.textContent = (e && e.message && e.message.length < 40) ? e.message : 'Try again';
      setTimeout(function () { if (!btn.disabled) btn.textContent = label; }, 2500);
    });
  }

  /* SMG_MULTIPICK (20 Oct 2026): chocolates in the cart panel. Same look as the product page sheet. */
  function upsellOpenMulti(p, name, card) {
    var vars = p.variants.map(function (v) { return { id: v.id, t: v.title, p: v.price, i: v.image || p.image || '' }; });
    window.smgMultiSheet.open({
      title: name,
      sub: 'Pick any mix, each in its own quantity.',
      vars: vars,
      unit: 'item', /* mixed singles and packs: "4 items, Rs 2,046" */
      doneLabel: function (n) { return n ? 'Add to cart' : 'Close'; },
      onDone: function (q, ui) {
        var items = vars.filter(function (v) { return q[v.id] > 0; }).map(function (v) { return { id: v.id, quantity: q[v.id] }; });
        if (!items.length) { ui.close(); return; }
        ui.busy(true);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            if (!r.ok) throw new Error(r.status === 429 ? 'Busy, please tap again' : (d.description || d.message || 'Could not add, please try again'));
            return d;
          });
        })
        .then(function () {
          upsellAdded[p.handle] = true;
          /* SMG_TRACK1013: one add_extra per type added. */
          try {
            if (window.smgTrack) vars.forEach(function (v) {
              if (q[v.id] > 0) window.smgTrack('add_extra', { extra_name: p.title || p.handle, extra_variant: v.t || '', value: v.p * q[v.id] / 100, currency: 'PKR', source: 'cart_rail' });
            });
          } catch (e) {}
          ui.busy(false);
          ui.close(true);
          return smgRefreshCartPanel();
        })
        .catch(function (e) {
          ui.busy(false);
          ui.error((e && e.message) || 'Could not add, please try again');
        });
      }
    });
  }

  function upsellRender(cart) {
    if (!cartBody) return;
    var items = (cart && cart.items) || [];
    var data = upsellLoad();
    var inCart = {}, hasMain = false, hasCake = false, hasFlower = false;
    items.forEach(function (it) {
      inCart[it.handle] = true;
      if (upsellIsAddon(it)) return;
      hasMain = true;
      /* Type and title both count: an Accessories Box called "Handbag
         Flowers and Balloon ..." already carries flowers. */
      var t = ((it.product_type || '') + ' ' + (it.product_title || '')).toLowerCase();
      if (/\bcakes?\b/.test(t) || window.smgCakeBoxTagged(it)) hasCake = true;
      if (/flower|\broses?\b|bouquet|floral/.test(t)) hasFlower = true;
    });
    /* Added here, then removed from the cart: offer it again. */
    Object.keys(upsellAdded).forEach(function (h) { if (!inCart[h] || UPSELL_BOXES.indexOf(h) !== -1) delete upsellAdded[h]; });

    /* The cart page lists the cart itself and would not refresh after an add here. */
    var onCartPage = /^\/cart\/?$/.test(window.location.pathname);
    var show = (!hasMain || onCartPage) ? [] : UPSELL_ORDER.filter(function (h) {
      if (!data[h]) return false;
      if (upsellAdded[h]) return true;
      if (inCart[h]) return false;
      if (h === UPSELL_ROSES && hasFlower) return false;
      if (h === 'layers-cakes' && hasCake) return false;
      if (h === 'custom-gift-tag' && !hasCake) return false;
      return true;
    }).slice(0, UPSELL_MAX);

    /* SMG_RAILBOX: boxes first, and only while a cake has no box. */
    var cb = window.smgCakeBoxCount(items);
    upsellBoxNeed = !onCartPage && cb.cake > cb.box;
    if (upsellBoxNeed) show = UPSELL_BOXES.filter(function (h) { return !!data[h]; }).concat(show);
    else upsellBoxNeed = false;

    if (!show.length) {
      if (upsellEl && upsellEl.parentNode) upsellEl.parentNode.removeChild(upsellEl);
      return;
    }
    if (!upsellEl) upsellBuildShell();

    Array.prototype.slice.call(upsellTrack.children).forEach(function (c) {
      if (show.indexOf(c.dataset.handle) === -1) upsellTrack.removeChild(c);
    });
    show.forEach(function (h) {
      if (!upsellCards[h]) upsellCards[h] = upsellBuildCard(data[h]);
      var card = upsellCards[h];
      var added = !!upsellAdded[h];
      card.classList.toggle('is-added', added);
      var btn = card.querySelector('.smg-upsell__add');
      if (btn && !btn.classList.contains('is-loading')) {
        btn.textContent = added ? 'Added' : (card._smgAddLabel || 'Add');
        btn.setAttribute('aria-disabled', added ? 'true' : 'false');
      }
      card.querySelectorAll('.smg-upsell__select').forEach(function (s) { s.disabled = added; });
      var mp = card.querySelector('.smg-upsell__pick--multi');
      if (mp) { mp.classList.toggle('is-disabled', added); mp.setAttribute('aria-disabled', added ? 'true' : 'false'); }
      upsellTrack.appendChild(card);
    });
    if (show.indexOf(UPSELL_CARD_HANDLE) === -1 || upsellAdded[UPSELL_CARD_HANDLE]) upsellCloseForm();

    /* SMG_RAILBOX: the subtitle asks for the box while one is missing. */
    var sub = upsellEl.querySelector('.smg-upsell__sub');
    if (sub) sub.textContent = upsellBoxNeed ? 'Every cake goes in a gift box. Choose one below.' : 'Little extras delivered with your gift, tap to add.';
    upsellEl.classList.toggle('smg-upsell--boxneed', upsellBoxNeed);

    cartBody.appendChild(upsellEl);
    upsellApplyCollapsed();
    upsellTrack.scrollLeft = upsellScroll;
  }

  /* The rail must never break the cart itself. */
  function smgUpsellSafe(cart) {
    try { upsellRender(cart); } catch (e) { if (window.console) console.warn('SMG extras rail:', e); }
  }

  /* Expose for product page AJAX */
  window.SMGCart = { open: smgOpenCart, close: smgCloseCart, refresh: smgRefreshCartPanel };

  /* GA4 view_item / add_to_cart / begin_checkout come from the Google and YouTube app pixel (5 Oct 2026); the theme sending them too counted every product view and add twice. */
})();

/* ── Delivery city, chosen once (5 Oct 2026) ──
   We deliver only in Lahore and Gujranwala. The header control opens a two
   option chooser; the choice sits in localStorage (smgCity) and drives the
   quiet delivery line on cards and the product page, and prefills the cart
   form. Never opens by itself. Pages that swap cards in call SMGCity.paint(). */
(function () {
  var KEY = 'smgCity', CITIES = ['Lahore', 'Gujranwala'], mem = '';
  var PIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';
  var dlg = null, lastFocus = null;

  function get() {
    var v = mem;
    try { v = window.localStorage.getItem(KEY) || mem; } catch (e) {}
    return CITIES.indexOf(v) > -1 ? v : '';
  }
  function pkHour() {
    return new Date(Date.now() + new Date().getTimezoneOffset() * 60000 + 5 * 3600000).getHours();
  }
  function labels() {
    var c = get();
    document.querySelectorAll('[data-smg-city-label]').forEach(function (el) { el.textContent = c || 'Choose city'; });
    document.querySelectorAll('[data-smg-city-prefix]').forEach(function (el) { el.hidden = !c; });
    document.querySelectorAll('[data-smg-city-open]').forEach(function (el) {
      el.setAttribute('aria-label', c ? 'Delivering to ' + c + ', change city' : 'Choose delivery city');
    });
  }
  function paint(root) {
    var c = get(), where = c || 'Lahore and Gujranwala';
    var late = pkHour() >= 15;
    (root || document).querySelectorAll('[data-smg-eta]').forEach(function (el) {
      var kind = el.getAttribute('data-smg-eta');
      /* next-day: tag delivery:next-day (Hamza, 10 Oct 2026), delivered tomorrow even when ordered after 3 PM */
      var txt = kind === 'custom'
        ? 'Delivers in 2 to 3 days'
        : kind === 'next-day'
          ? 'Delivers tomorrow in ' + where
          : (late ? 'Delivers tomorrow in ' : 'Delivers today in ') + where;
      /* Product page line only: same day is always subject to availability (Hamza, 10 Oct 2026) */
      if (txt.indexOf('Delivers today') === 0 && el.classList.contains('smg-eta--pdp')) txt += ', subject to availability';
      if (el.textContent !== txt) el.textContent = txt;
    });
  }
  function set(city, source) {
    if (CITIES.indexOf(city) === -1) return;
    var prev = get();
    mem = city;
    try { window.localStorage.setItem(KEY, city); } catch (e) {}
    labels();
    paint();
    if (dlg) dlg.querySelectorAll('[data-city]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-city') === city)); });
    if (prev === city) return;
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', 'select_content', { content_type: 'city', item_id: city }); } catch (e) {}
    }
    try { document.dispatchEvent(new CustomEvent('smg:city', { detail: { city: city, source: source || 'header' } })); } catch (e) {}
  }

  function build() {
    dlg = document.createElement('div');
    dlg.className = 'smg-cityd';
    dlg.hidden = true;
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-labelledby', 'smgCitydTitle');
    dlg.innerHTML =
      '<div class="smg-cityd__overlay" data-smg-cityd-close></div>' +
      '<div class="smg-cityd__box">' +
        '<button type="button" class="smg-cityd__x" data-smg-cityd-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<h2 class="smg-cityd__title" id="smgCitydTitle">Where should we deliver?</h2>' +
        '<p class="smg-cityd__sub">Our own riders deliver across Lahore and Gujranwala.</p>' +
        '<div class="smg-cityd__opts">' +
          CITIES.map(function (c) {
            return '<button type="button" class="smg-cityd__opt" data-city="' + c + '" aria-pressed="false">' + PIN + c + '</button>';
          }).join('') +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-city]');
      if (opt) { set(opt.getAttribute('data-city'), 'header'); close(); return; }
      if (e.target.closest('[data-smg-cityd-close]')) close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = dlg.querySelectorAll('button');
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  function open() {
    if (!dlg) build();
    var c = get();
    dlg.querySelectorAll('[data-city]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-city') === c)); });
    lastFocus = document.activeElement;
    dlg.hidden = false;
    var target = dlg.querySelector('[aria-pressed="true"]') || dlg.querySelector('[data-city]');
    if (target) target.focus();
  }
  function close() {
    if (!dlg || dlg.hidden) return;
    dlg.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-smg-city-open]');
    if (b) { e.preventDefault(); open(); }
  });

  window.SMGCity = { get: get, set: set, open: open, close: close, paint: paint };
  labels();
  paint();
  /* Today turns into tomorrow at 3 PM Pakistan time while the page is open */
  setInterval(function () { paint(); }, 60000);
})();

/* ── SMG_PICK: styled picker in place of native dropdowns (11 Oct 2026) ──
   Hamza asked for "better dropdowns, not html dropdowns". The native select
   stays in the page as the source of truth (form submits, required checks and
   every existing change handler keep working); it is hidden and a button opens
   a bottom sheet (a centred dialog from 700px) listing each option with its
   photo and price. Picking a row sets select.value and fires 'change'.
   Used by the add on cards (sections/smg-cake-addons.liquid, selects marked
   data-smg-pick) and the cart extras rail below. The sheet lives on <body>
   with global styles in smg-shared.css, because the cart panel is transformed
   (fixed children would be trapped inside it). */
(function () {
  var sheet = null, list = null, titleEl = null, searchEl = null, cur = null, lastFocus = null;

  function money(c) { return 'Rs ' + Math.round(c / 100).toLocaleString('en-US'); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function realOpts(sel) { return Array.prototype.filter.call(sel.options, function (o) { return o.value !== '' && !o.disabled; }); }
  function info(o, cfg) {
    var name = o.getAttribute('data-name') || (o.textContent || '').trim().replace(/,\s*Rs\.?\s?[\d,]+$/, '');
    var p = o.getAttribute('data-price');
    return { value: o.value, name: name, price: p ? parseInt(p, 10) : null, image: o.getAttribute('data-image') || cfg.image || '' };
  }
  function placeholder(sel) {
    var o = sel.options[0];
    var t = o && o.value === '' ? (o.textContent || '').trim() : '';
    if (!t) return 'Choose an option';
    if (/^select\s+/i.test(t)) return t.replace(/^select\s+/i, 'Choose ');
    return /^choose\b/i.test(t) ? t : 'Choose ' + t.toLowerCase();
  }

  function build() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'smg-pick-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="smg-pick-sheet__box" role="dialog" aria-modal="true" aria-labelledby="smgPickTitle">' +
        '<div class="smg-pick-sheet__head"><h3 class="smg-pick-sheet__title" id="smgPickTitle"></h3>' +
        '<button type="button" class="smg-pick-sheet__x" aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg></button></div>' +
        '<input type="search" class="smg-pick-sheet__search" placeholder="Search" aria-label="Search the options" autocomplete="off" hidden>' +
        '<div class="smg-pick-sheet__list" role="listbox"></div>' +
      '</div>';
    document.body.appendChild(sheet);
    list = sheet.querySelector('.smg-pick-sheet__list');
    titleEl = sheet.querySelector('.smg-pick-sheet__title');
    searchEl = sheet.querySelector('.smg-pick-sheet__search');
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || (e.target.closest && e.target.closest('.smg-pick-sheet__x'))) { close(); return; }
      var r = e.target.closest && e.target.closest('.smg-pick-row');
      if (r) choose(r.getAttribute('data-v'));
    });
    searchEl.addEventListener('input', function () { rows(searchEl.value); });
    /* Capture phase on window, so Escape closes only the sheet and not the cart panel under it. */
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && !sheet.hidden) { e.stopPropagation(); e.preventDefault(); close(); }
    }, true);
  }

  function rows(q) {
    var sel = cur.sel, cfg = cur.cfg;
    q = (q || '').trim().toLowerCase();
    var all = realOpts(sel).map(function (o) { return info(o, cfg); });
    var prices = {}; all.forEach(function (x) { if (x.price != null) prices[x.price] = 1; });
    var showPrice = Object.keys(prices).length > 1;
    var thumbs = all.some(function (x) { return x.image; });
    var html = all.filter(function (x) { return !q || x.name.toLowerCase().indexOf(q) !== -1; }).map(function (x) {
      var on = x.value === sel.value;
      return '<button type="button" role="option" aria-selected="' + on + '" class="smg-pick-row' + (on ? ' is-on' : '') + '" data-v="' + esc(x.value) + '">' +
        (thumbs ? (x.image ? '<img class="smg-pick-row__img" src="' + esc(x.image) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="smg-pick-row__img smg-pick-row__img--none" aria-hidden="true"></span>') : '') +
        '<span class="smg-pick-row__name">' + esc(x.name) + '</span>' +
        (showPrice && x.price != null ? '<span class="smg-pick-row__price">' + money(x.price) + '</span>' : '') +
        '<span class="smg-pick-row__tick" aria-hidden="true">' + (on ? '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '') + '</span>' +
      '</button>';
    }).join('');
    list.innerHTML = html || '<p class="smg-pick-sheet__none">No match</p>';
  }

  function open(sel) {
    var api = sel._smgPick;
    if (!api || sel.disabled) return;
    build();
    cur = api;
    lastFocus = document.activeElement;
    titleEl.textContent = api.cfg.title || placeholder(sel);
    var many = realOpts(sel).length > 12;
    searchEl.hidden = !many; searchEl.value = '';
    rows('');
    sheet.hidden = false;
    document.documentElement.classList.add('smg-pick-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    var on = list.querySelector('.is-on');
    if (on && on.scrollIntoView) on.scrollIntoView({ block: 'center' });
    var f = (window.matchMedia && window.matchMedia('(min-width: 700px)').matches && many) ? searchEl : (on || list.querySelector('.smg-pick-row') || sheet.querySelector('.smg-pick-sheet__x'));
    if (f) f.focus({ preventScroll: true });
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('smg-pick-lock');
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 180);
    var t = cur && cur.trigger;
    if (t && t.focus) t.focus({ preventScroll: true }); else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function choose(v) {
    var sel = cur && cur.sel;
    if (!sel) return;
    sel.value = v;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    cur.sync();
    close();
  }

  window.smgEnhanceSelect = function (sel, cfg) {
    if (!sel || sel.tagName !== 'SELECT') return null;
    if (sel._smgPick) { sel._smgPick.sync(); return sel._smgPick; }
    cfg = cfg || {};
    var api = { sel: sel, cfg: cfg, trigger: null };
    var own = !cfg.trigger, btn;
    if (own) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'smg-pick-btn' + (cfg.size ? ' smg-pick-btn--' + cfg.size : '');
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.id = (sel.id || ('smgPick' + Math.random().toString(36).slice(2, 8))) + '-pick';
      btn.innerHTML = '<span class="smg-pick-btn__img" aria-hidden="true"></span><span class="smg-pick-btn__txt"><span class="smg-pick-btn__name"></span><span class="smg-pick-btn__price"></span></span>' +
        '<svg class="smg-pick-btn__chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
      sel.parentNode.insertBefore(btn, sel);
      var lab = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
      if (lab) lab.htmlFor = btn.id;
    } else {
      btn = cfg.trigger;
      if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(sel); } });
    }
    api.trigger = btn;
    sel.classList.add('smg-pick-native');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');
    btn.addEventListener('click', function (e) { e.preventDefault(); open(sel); });

    api.sync = function () {
      if (own) {
        var o = sel.options[sel.selectedIndex];
        var has = o && o.value !== '';
        var x = has ? info(o, cfg) : null;
        var im = btn.querySelector('.smg-pick-btn__img');
        var src = x ? x.image : (cfg.image || '');
        im.innerHTML = src ? '<img src="' + esc(src) + '" alt="" width="34" height="34">' : '';
        im.hidden = !src;
        btn.querySelector('.smg-pick-btn__name').textContent = x ? x.name : placeholder(sel);
        var pr = btn.querySelector('.smg-pick-btn__price');
        pr.textContent = x && x.price != null ? money(x.price) : '';
        pr.hidden = !(x && x.price != null);
        btn.classList.toggle('is-empty', !has);
        btn.disabled = !!sel.disabled;
      } else {
        btn.classList.toggle('is-disabled', !!sel.disabled);
      }
      btn.classList.toggle('is-invalid', sel.classList.contains('is-invalid'));
    };
    api.open = function () { open(sel); };
    sel.addEventListener('change', api.sync);
    sel.addEventListener('invalid', function () { btn.classList.add('is-invalid'); });
    if (window.MutationObserver) new MutationObserver(api.sync).observe(sel, { attributes: true, attributeFilter: ['class', 'disabled'] });
    sel._smgPick = api;
    api.sync();
    return api;
  };

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('select[data-smg-pick]'), function (s) {
      window.smgEnhanceSelect(s, { title: s.getAttribute('data-pick-title') || '', image: s.getAttribute('data-pick-img') || '', size: s.getAttribute('data-pick-size') || '' });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();

/* ── SMG_MULTIPICK (20 Oct 2026): sheet for picking several types, each in its own quantity ──
   window.smgMultiSheet.open({ title, sub, vars: [{id, t, p, i}], qty: {id: n}, min, unit,
   doneLabel(n), onChange(qty), onDone(qty, ui) }). Used by the cart panel rail (chocolates).
   The product page cards have the same sheet inside sections/smg-cake-addons.liquid. The look
   reuses the SMG_PICK sheet classes in smg-shared.css; the row styles are added here once. */
(function () {
  var sheet = null, list = null, cfg = null, q = {}, lastFocus = null;
  var CSS = '.smg-multi-sheet__sub{margin:0;padding:8px 18px 6px;border-bottom:1px solid var(--smg-border,#F0E0E6);font-size:13px;line-height:1.4;color:var(--smg-text-muted,#7A5A65)}' +
    '.smg-multi-row{display:flex;align-items:center;gap:10px;min-height:64px;padding:6px 8px 6px 10px;border-radius:12px}' +
    '.smg-multi-row+.smg-multi-row{margin-top:2px}' +
    '.smg-multi-row.is-on{background:#FFF3F6;box-shadow:inset 0 0 0 1.5px var(--smg-primary,#E8365D)}' +
    '.smg-multi-row__txt{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}' +
    '.smg-multi-row__name{font-size:14.5px;font-weight:500;line-height:1.3;color:var(--smg-text,#2D2024);overflow-wrap:anywhere}' +
    '.smg-multi-row.is-on .smg-multi-row__name{font-weight:700;color:var(--smg-deep,#4A1228)}' +
    '.smg-multi-row__price{font-size:13px;font-weight:700;color:var(--smg-secondary,#C23A5C);font-variant-numeric:tabular-nums}' +
    '.smg-multi-row__step{flex:0 0 auto;display:flex;align-items:center;height:44px;border:1.5px solid var(--smg-border,#F0E0E6);border-radius:10px;overflow:hidden;background:#fff}' +
    '.smg-multi-row.is-on .smg-multi-row__step{border-color:var(--smg-primary,#E8365D)}' +
    '.smg-multi-row__btn{flex:0 0 42px;width:42px;height:44px;border:0;background:#fff;color:var(--smg-primary,#E8365D);font-family:inherit;font-size:22px;font-weight:600;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;touch-action:manipulation}' +
    '.smg-multi-row__btn[data-d="1"]{background:var(--smg-primary,#E8365D);color:#fff}' +
    '.smg-multi-row__btn:disabled{color:#D9C3CB;cursor:default}' +
    '.smg-multi-row__btn[data-d="1"]:disabled{background:#F3D3DC;color:#fff}' +
    '.smg-multi-row__btn:focus-visible{outline:2px solid var(--smg-deep,#4A1228);outline-offset:-3px}' +
    '.smg-multi-row__num{flex:0 0 30px;text-align:center;font-size:15px;font-weight:700;color:var(--smg-deep,#4A1228);font-variant-numeric:tabular-nums}' +
    '.smg-multi-sheet__foot{display:flex;flex-wrap:wrap;align-items:center;gap:6px 12px;padding:12px 16px 14px;border-top:1px solid var(--smg-border,#F0E0E6)}' +
    '.smg-multi-sheet__total{flex:1 1 auto;min-width:0;font-size:14.5px;font-weight:700;color:var(--smg-deep,#4A1228);font-variant-numeric:tabular-nums}' +
    '.smg-multi-sheet__total.is-empty{font-weight:500;color:var(--smg-text-muted,#7A5A65)}' +
    '.smg-multi-sheet__done{flex:0 0 auto;min-width:128px;height:48px;padding:0 20px;border:0;border-radius:12px;background:var(--smg-primary,#E8365D);color:#fff;font-family:inherit;font-size:15px;font-weight:700;cursor:pointer}' +
    '.smg-multi-sheet__done:disabled{opacity:.7;cursor:progress}' +
    '.smg-multi-sheet__done:focus-visible{outline:3px solid #F5A0B5;outline-offset:2px}' +
    '.smg-multi-sheet__msg{flex:1 1 100%;order:-1;margin:0;font-size:12.5px;font-weight:600;line-height:1.4;color:var(--smg-primary,#E8365D)}' +
    '.smg-multi-sheet__msg[hidden]{display:none}' +
    '.smg-upsell__pick--multi{cursor:pointer}.smg-upsell__pick--multi.is-disabled{opacity:.55;cursor:default}';

  function money(c) { return 'Rs ' + Math.round(c / 100).toLocaleString('en-US'); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function count() { return Object.keys(q).reduce(function (a, k) { return a + q[k]; }, 0); }
  function sum() { return cfg.vars.reduce(function (a, v) { return a + v.p * (q[v.id] || 0); }, 0); }
  function words(n) { var u = cfg.unit || 'item'; return n + ' ' + (n === 1 ? u : u + 's'); }
  function min() { return Math.max(1, cfg.min || 1); }

  function build() {
    if (sheet) return;
    if (!document.getElementById('smgMultiCss')) {
      var st = document.createElement('style'); st.id = 'smgMultiCss'; st.textContent = CSS; document.head.appendChild(st);
    }
    sheet = document.createElement('div');
    sheet.className = 'smg-pick-sheet smg-multi-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="smg-pick-sheet__box" role="dialog" aria-modal="true" aria-labelledby="smgMultiSheetTitle">' +
        '<div class="smg-pick-sheet__head"><h3 class="smg-pick-sheet__title" id="smgMultiSheetTitle"></h3>' +
        '<button type="button" class="smg-pick-sheet__x" aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg></button></div>' +
        '<p class="smg-multi-sheet__sub"></p>' +
        '<div class="smg-pick-sheet__list" role="list"></div>' +
        '<div class="smg-multi-sheet__foot"><p class="smg-multi-sheet__msg" role="alert" hidden></p><span class="smg-multi-sheet__total" aria-live="polite"></span><button type="button" class="smg-multi-sheet__done">Done</button></div>' +
      '</div>';
    document.body.appendChild(sheet);
    list = sheet.querySelector('.smg-pick-sheet__list');
    sheet.addEventListener('click', function (e) {
      var t = e.target;
      if (t === sheet || (t.closest && t.closest('.smg-pick-sheet__x'))) { close(); return; }
      if (t.closest && t.closest('.smg-multi-sheet__done')) {
        var n = count();
        if (n > 0 && n < min()) { foot(true); return; }
        if (cfg.onDone) cfg.onDone(JSON.parse(JSON.stringify(q)), ui); else close();
        return;
      }
      var b = t.closest && t.closest('.smg-multi-row__btn');
      if (b && !b.disabled) step(b.closest('.smg-multi-row').getAttribute('data-id'), parseInt(b.getAttribute('data-d'), 10));
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && !sheet.hidden) { e.stopPropagation(); e.preventDefault(); close(); }
    }, true);
  }
  function row(v) {
    var n = q[v.id] || 0, name = esc(v.t);
    return '<div class="smg-multi-row' + (n ? ' is-on' : '') + '" role="listitem" data-id="' + v.id + '">' +
      (v.i ? '<img class="smg-pick-row__img" src="' + esc(v.i) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="smg-pick-row__img" aria-hidden="true"></span>') +
      '<span class="smg-multi-row__txt"><span class="smg-multi-row__name">' + name + '</span><span class="smg-multi-row__price">' + money(v.p) + '</span></span>' +
      '<span class="smg-multi-row__step">' +
        '<button type="button" class="smg-multi-row__btn" data-d="-1" aria-label="One less ' + name + '"' + (n ? '' : ' disabled') + '>\u2212</button>' +
        '<span class="smg-multi-row__num" aria-live="polite">' + n + '</span>' +
        '<button type="button" class="smg-multi-row__btn" data-d="1" aria-label="One more ' + name + '"' + (n >= 20 ? ' disabled' : '') + '>+</button>' +
      '</span></div>';
  }
  function foot(showMsg) {
    var n = count();
    var tot = sheet.querySelector('.smg-multi-sheet__total');
    tot.textContent = n ? words(n) + ', ' + money(sum()) : 'Nothing picked yet';
    tot.classList.toggle('is-empty', !n);
    var done = sheet.querySelector('.smg-multi-sheet__done');
    if (!done.disabled) done.textContent = cfg.doneLabel ? cfg.doneLabel(n) : 'Done';
    var msg = sheet.querySelector('.smg-multi-sheet__msg');
    var short = n > 0 && n < min();
    if (!short && !msg.getAttribute('data-err')) msg.hidden = true;
    else if (short && (showMsg || !msg.hidden)) { msg.textContent = 'Please choose at least ' + min() + ' in total (' + (min() - n) + ' more), or set them all to 0.'; msg.hidden = false; }
  }
  function step(id, d) {
    var n = Math.max(0, Math.min(20, (q[id] || 0) + d));
    if (n) q[id] = n; else delete q[id];
    var r = list.querySelector('.smg-multi-row[data-id="' + id + '"]');
    if (r) {
      r.classList.toggle('is-on', n > 0);
      r.querySelector('.smg-multi-row__num').textContent = String(n);
      var bs = r.querySelectorAll('.smg-multi-row__btn');
      bs[0].disabled = n <= 0; bs[1].disabled = n >= 20;
      if (document.activeElement && document.activeElement.disabled) (n <= 0 ? bs[1] : bs[0]).focus();
    }
    var msg = sheet.querySelector('.smg-multi-sheet__msg');
    msg.removeAttribute('data-err');
    foot(false);
    if (cfg.onChange) cfg.onChange(JSON.parse(JSON.stringify(q)));
  }
  function close(force) {
    if (!sheet || sheet.hidden) return;
    var n = count();
    if (!force && n > 0 && n < min()) { foot(true); return; }
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('smg-pick-lock');
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 180);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  var ui = {
    close: close,
    busy: function (on) {
      var d = sheet.querySelector('.smg-multi-sheet__done');
      d.disabled = !!on;
      if (on) d.textContent = 'Adding...'; else d.textContent = cfg.doneLabel ? cfg.doneLabel(count()) : 'Done';
    },
    error: function (t) {
      var msg = sheet.querySelector('.smg-multi-sheet__msg');
      msg.textContent = t; msg.setAttribute('data-err', '1'); msg.hidden = false;
    }
  };
  function open(o) {
    build();
    cfg = o || {};
    q = {};
    Object.keys(cfg.qty || {}).forEach(function (k) { if (cfg.qty[k] > 0) q[k] = cfg.qty[k]; });
    lastFocus = document.activeElement;
    sheet.querySelector('.smg-pick-sheet__title').textContent = cfg.title || 'Choose';
    sheet.querySelector('.smg-multi-sheet__sub').textContent = cfg.sub || '';
    var msg = sheet.querySelector('.smg-multi-sheet__msg');
    msg.hidden = true; msg.removeAttribute('data-err');
    var done = sheet.querySelector('.smg-multi-sheet__done');
    done.disabled = false;
    list.innerHTML = (cfg.vars || []).map(row).join('');
    list.scrollTop = 0;
    foot(false);
    sheet.hidden = false;
    document.documentElement.classList.add('smg-pick-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    var f = list.querySelector('.smg-multi-row__btn[data-d="1"]') || sheet.querySelector('.smg-pick-sheet__x');
    if (f) f.focus({ preventScroll: true });
  }
  window.smgMultiSheet = { open: open, close: close };
})();


/* SMG_TODAYPRICE (25 Oct 2026, Hamza): from 3 PM Pakistan time until midnight, show the
   "today" price (+10%) on same day gifts. Elements carry data-smg-today and the hidden
   attribute; a class on <html> reveals them, so cards loaded later show too. */
(function () {
  try {
    var st = document.createElement('style');
    st.textContent = 'html.smg-after3 [data-smg-today][hidden]{display:block!important}html.smg-after3 [data-smg-today="flex"][hidden]{display:flex!important}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
  function tick() {
    var h = new Date(Date.now() + new Date().getTimezoneOffset() * 60000 + 5 * 3600000).getHours();
    document.documentElement.classList.toggle('smg-after3', h >= 15);
  }
  tick();
  setInterval(tick, 60000);
})();

/* SMG_RO_SOUND (25 Oct 2026): sound button on gift idea videos that have music.
   The button (data-snd) and data-music on the video are rendered only when the Real order entry has
   has_music ticked (snippets/smg-real-order-video.liquid). Videos start muted, since browsers block
   autoplay with sound; a tap unmutes (and plays, inside the tap, so mobile Safari allows the sound).
   Unmuting any video mutes every other video on the page. The button also follows the video's own
   controls. Delegated from document, so it works in the viewers whose slides come from a template. */
(function () {
  function sync(v) {
    var b = v.parentNode && v.parentNode.querySelector('[data-snd]');
    if (b) b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-snd]');
    if (!b) return;
    var v = b.parentNode.querySelector('video[data-music]');
    if (!v) return;
    if (v.muted) {
      v.muted = false;
      if (v.volume === 0) v.volume = 1;
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    } else {
      v.muted = true;
    }
    sync(v);
  });
  document.addEventListener('volumechange', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || !v.hasAttribute('data-music')) return;
    if (!v.muted) Array.prototype.forEach.call(document.querySelectorAll('video'), function (o) { if (o !== v && !o.muted) o.muted = true; });
    sync(v);
  }, true);
})();


/* SMG_REF (26 Oct 2026): creator and campaign codes. A link like sendmygift.pk/?ref=AYESHA is remembered
   for 30 days and printed as "Ref: AYESHA" in every WhatsApp message (cart order, floating button, product
   buttons), so the team can record which creator or ad brought the order (Source field in the ops admin). */
(function () {
  var KEY = 'smgRef', DAYS = 30;
  function clean(v) { v = String(v || '').trim().toUpperCase().replace(/[^A-Z0-9_]/g, ''); return v.length >= 2 && v.length <= 30 ? v : ''; }
  try {
    var q = new URLSearchParams(location.search), c = clean(q.get('ref'));
    if (c) localStorage.setItem(KEY, JSON.stringify({ c: c, t: Date.now() }));
  } catch (e) {}
  window.smgRefCode = function () {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (s && s.c && Date.now() - s.t < DAYS * 86400000) return s.c;
    } catch (e) {}
    return '';
  };
  /* Plain wa.me links: add the code to the prefilled text just before the tap opens WhatsApp. */
  document.addEventListener('click', function (e) {
    var code = window.smgRefCode(); if (!code) return;
    var a = e.target && e.target.closest && e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/send"]');
    if (!a || a.id === 'smgCartWaFallback') return;
    try {
      var u = new URL(a.href), t = u.searchParams.get('text') || '';
      if (t.indexOf('Ref: ' + code) !== -1) return;
      u.searchParams.delete('text');
      var rest = u.searchParams.toString();
      /* encodeURIComponent, not searchParams.set: WhatsApp can show a "+" for a space */
      a.href = u.origin + u.pathname + '?' + (rest ? rest + '&' : '') + 'text=' + encodeURIComponent((t ? t + '\n\n' : '') + 'Ref: ' + code);
    } catch (err) {}
  }, true);
})();
